import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import copyJson from "./order-ledger-copy.json";

const text = z.string().min(1);

const copySchema = z.object({
  amendmentLabels: z.object({
    direction: text,
    contactId: text,
    chemicalName: text,
    casNumber: text,
    quantity: text,
    unit: text,
    pricePerItem: text,
    internalProductNumber: text,
    externalProductNumber: text,
    referenceNumber: text,
    customerPoNumber: text,
    contactAddressId: text,
    requestedBy: text,
    customerRequestorContactPersonId: text,
    deliverySchedule: text,
    notes: text,
  }),
  historyFields: z.object({
    amount: text,
    datePaid: text,
    invoiceNumber: text,
    invoiceDate: text,
    notes: text,
    date: text,
    quantity: text,
    carrier: text,
    trackingNumber: text,
    address: text,
    moved: text,
    cancellationReason: text,
  }),
  historyTemplates: z.object({ line: text, internalBatch: text, externalBatch: text, movedOf: text }),
  views: z.object({
    pending: text,
    fulfilled: text,
    fulfilledBalanceDue: text,
    cancelled: text,
    all: text,
    openSales: text,
    missingPrice: text,
  }),
});

const copy = copySchema.parse(copyJson);

export const ORDER_AMENDMENT_FIELD_LABELS = copy.amendmentLabels;
export const ORDER_HISTORY_FIELD_LABELS = copy.historyFields;
export const ORDER_VIEW_LABELS = copy.views;

export function historyLineLabel(number: number): string {
  return fillTemplate(copy.historyTemplates.line, { number });
}

export function internalBatchText(batch: string): string {
  return fillTemplate(copy.historyTemplates.internalBatch, { batch });
}

export function externalBatchText(batch: string): string {
  return fillTemplate(copy.historyTemplates.externalBatch, { batch });
}

export function movedOfText(moved: string, ordered: string, unit: string): string {
  return fillTemplate(copy.historyTemplates.movedOf, { moved, ordered, unit });
}
